import { Component, Input } from '@angular/core';
import { BadgeColors } from './badge.constants';

@Component({
	selector: 'badge',
	templateUrl: './badge.component.html',
	styleUrls: ['./badge.component.scss'],
	standalone: false
})
export class BadgeComponent {
	@Input() public badgeLabel: string;
	@Input() public badgeColor: BadgeColors;

	constructor () {}
}
